import React, { Component } from 'react'
import { Link } from 'react-router'
import { Col, Row, Button } from 'react-bootstrap'
import moment from 'moment'
import { ShareButtons, ShareCounts, generateShareIcon } from 'react-share'
import { translate } from "react-translate"

@translate("NoteItem")
export default class NoteItem extends Component {

  _renderDate(date){
    moment.locale('es');
    var m = moment(date)
    let day = moment(m).format('dddd')
    let newDate = moment(m).format('LL')
    return (
      <h2 className="transform-date">{newDate}</h2>
    )
  }

  _magic(input) {
    return {__html: input}
  }

  render () {

    const { note, t } = this.props

    let shareStyle = {
      fill: '#292929',
      cursor: 'pointer',
      marginRight: '5px'
    }

    const { FacebookShareButton, GooglePlusShareButton, LinkedinShareButton, TwitterShareButton } = ShareButtons;

    const { FacebookShareCount, GooglePlusShareCount, LinkedinShareCount } = ShareCounts;

    const FacebookIcon = generateShareIcon('facebook');
    const TwitterIcon = generateShareIcon('twitter');
    const LinkedinIcon = generateShareIcon('linkedin');
    const GooglePlusIcon = generateShareIcon('google');
    const title = 'LJ Ramos';

    let baseUrl = window.location.href;
    let shareUrl = baseUrl + '/' + note.id

    return (
      <div>
        <div className="note-box">
          <div className="note-img">
            <img src={note.image} />
          </div>
          <div className="note-info">
            <Link to={'/note-imi/' + note.slug}><h1>{note.title}</h1></Link>
            <div>{this._renderDate(note.date)}</div>
            <div className="note-content">
              <h4 dangerouslySetInnerHTML={this._magic(note.content)} />
              {/*<a href="" target="_blank">Continuar leyendo</a> */}
            </div>
            <div className="bottom-info">
              <p className="hidden-xs">Autores</p>
              <div className="last-info">
                { (note.authors) ? (
                  note.authors.map((item, index) =>
                    <h5 className="hidden-xs" key={index}>{item.name}<span>, </span></h5>
                  )) : ''
                }
                <div className="social-share">
                  <p>{t('Compartir')}</p>
                  <div className="social-share-btns hidden-xs">
                    <FacebookShareButton
                      url={shareUrl}
                      title={title}>
                      <FacebookIcon
                        size={22}
                        round={true}
                        iconBgStyle={shareStyle} />
                    </FacebookShareButton>
                    <TwitterShareButton
                      url={shareUrl}
                      title={title}>
                      <TwitterIcon
                        size={22}
                        round={true}
                        iconBgStyle={shareStyle} />
                    </TwitterShareButton>
                    <GooglePlusShareButton
                      url={shareUrl}
                      title={title}>
                      <GooglePlusIcon
                        size={22}
                        round={true}
                        iconBgStyle={shareStyle} />
                    </GooglePlusShareButton>
                    <LinkedinShareButton
                      url={shareUrl}
                      title={title}>
                      <LinkedinIcon
                        size={22}
                        round={true}
                        iconBgStyle={shareStyle} />
                    </LinkedinShareButton>
                  </div>
                  <div className="social-share-btns visible-xs">
                    <FacebookShareButton
                      url={shareUrl}
                      title={title}>
                      <FacebookIcon
                        size={32}
                        round={true}
                        iconBgStyle={shareStyle} />
                    </FacebookShareButton>
                    <TwitterShareButton
                      url={shareUrl}
                      title={title}>
                      <TwitterIcon
                        size={32}
                        round={true}
                        iconBgStyle={shareStyle} />
                    </TwitterShareButton>
                    <GooglePlusShareButton
                      url={shareUrl}
                      title={title}>
                      <GooglePlusIcon
                        size={32}
                        round={true}
                        iconBgStyle={shareStyle} />
                    </GooglePlusShareButton>
                    <LinkedinShareButton
                      url={shareUrl}
                      title={title}>
                      <LinkedinIcon
                        size={32}
                        round={true}
                        iconBgStyle={shareStyle} />
                    </LinkedinShareButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="note-separator"></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Imi/Notes/item.js